import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 2C6.21 2 1.5 6.71 1.5 12.5S6.21 23 12 23s10.5-4.71 10.5-10.5S17.79 2 12 2m0 19.5c-4.965 0-9-4.035-9-9s4.035-9 9-9 9 4.035 9 9-4.043 9-9 9"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.008 11a.75.75 0 0 0-.75.75v6c0 .413.337.75.75.75.412 0 .75-.337.75-.75v-6a.75.75 0 0 0-.75-.75M12.008 6.5a.75.75 0 0 0-.75.75v1.5c0 .412.337.75.75.75.412 0 .75-.338.75-.75v-1.5a.75.75 0 0 0-.75-.75"
    }, null, -1)
  ]))]))
}
export default { render: render }